import { apiRequest } from './client.js';
import type { ProfileScopeRow } from './vendorBrandingProfileApi.js';

/**
 * Company branding profile (M17) — which branding work the company itself runs,
 * and where, per financial year.
 *
 * Financial years and the branding taxonomy are read through
 * vendorBrandingProfileApi: they are the same lists, and a second copy would
 * drift.
 */

export type GeoScopeLevel = 'ALL_INDIA' | 'STATE' | 'DISTRICT' | 'SUBDISTRICT';

export interface CompanyGeographyRow {
  readonly scopeId: string;
  readonly scopeType: GeoScopeLevel | string;
  readonly stateId: string | null;
  readonly districtId: string | null;
  readonly tehsilId: string | null;
  readonly label: string;
}

export interface CompanyBrandingProfile {
  readonly companyBrandingProfileId: string | null;
  readonly companyId: string;
  readonly planningCycleId: string;
  readonly cycleCode: string | null;
  readonly remarks: string | null;
  readonly version: number;
  readonly scope: readonly ProfileScopeRow[];
  readonly geography: readonly CompanyGeographyRow[];
}

export interface SaveCompanyProfileInput {
  readonly companyId: string;
  readonly planningCycleId: string;
  readonly remarks?: string;
  readonly scope: ReadonlyArray<{
    readonly brandingTypeId: string;
    readonly brandingItemId?: string;
  }>;
  readonly geography: ReadonlyArray<{
    readonly scopeType: GeoScopeLevel;
    readonly stateId?: string;
    readonly districtId?: string;
    readonly tehsilId?: string;
  }>;
}

type Tok = string | null | undefined;

const BASE = '/v1/m17/company-branding-profiles';

export function getCompanyBrandingProfile(
  companyId: string,
  planningCycleId: string,
  token?: Tok,
): Promise<CompanyBrandingProfile> {
  const qs = new URLSearchParams({ companyId, planningCycleId });
  return apiRequest<CompanyBrandingProfile>(`${BASE}?${qs.toString()}`, { token });
}

export function saveCompanyBrandingProfile(
  body: SaveCompanyProfileInput,
  token?: Tok,
): Promise<CompanyBrandingProfile> {
  return apiRequest<CompanyBrandingProfile>(BASE, { method: 'PUT', body, token });
}
